import React from "react";
import { Fish } from "lucide-react";

/**
 * Stylized Carlos Medeiros logo: "CM" in Cormorant Garamond with a small
 * ichthys (fish) icon from lucide-react in soft gold.
 */
export default function Logo({ className = "", light = false }) {
  const textColor = light ? "text-white" : "text-[#0B1E36]";
  const goldColor = "text-[#C5A059]";
  return (
    <a
      href="/"
      data-testid="logo-home-link"
      className={`flex items-center gap-2 group ${className}`}
      aria-label="Carlos Medeiros - Início"
    >
      <span
        className={`font-serif-display text-3xl leading-none tracking-tight ${textColor}`}
      >
        CM
      </span>
      <Fish
        strokeWidth={1.5}
        className={`w-5 h-5 ${goldColor} transition-transform duration-500 group-hover:-rotate-6 group-hover:translate-x-0.5`}
      />
    </a>
  );
}
